// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"_2CleU","mobile":"_31fGi","on-image":"WIhJ-","onImage":"WIhJ-","product-info":"_1xNv9","productInfo":"_1xNv9","rectangle":"_1jpTC"};